import * as React from "react"

/**
 * Simple Tailwind-based Slider component
 * Props:
 *  - value: number
 *  - onChange: (newValue: number) => void
 *  - min?: number
 *  - max?: number
 */
export function Slider({ value = 0, onChange, min = 0, max = 100 }) {
  return (
    <input
      type="range"
      min={min}
      max={max}
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      className="w-full h-2 bg-gray-700 rounded-lg appearance-none cursor-pointer"
    />
  )
}
